import InterestedRobotSvg from '@/assets/InterestedRobotSvg.svg';
import DialogMobile from '@/components/dialog/DialogMobile.tsx';
import { generateNonCachableImageSrc } from '@/utils/generateNonCachableImageSrc.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import React from 'react';

interface EmailConfirmationMobileProps {
  onResendClick: () => void;
  resendDone: boolean;
}

const EmailConfirmationMobile: React.FC<EmailConfirmationMobileProps> = ({
  onResendClick,
  resendDone,
}) => {
  const { t } = useTranslationWithPrefix('welcomePage.popup');

  return (
    <DialogMobile
      content={t('subMessage')}
      image={
        <img
          alt="popup-robot"
          className="object-cover"
          src={generateNonCachableImageSrc(InterestedRobotSvg)}
        />
      }
      message={t('message')}
      subMessage={
        resendDone ? (
          <p className="small pt-2 text-primary" style={{ paddingBottom: '16px' }}>
            {t('resendEmailSent')}
          </p>
        ) : (
          <p className="small pt-2">
            {t('emailNotReceived1')}
            <button className="btn btn-link" onClick={onResendClick} type="button">
              <span className="small fw-bold pb-[2px]">{t('emailNotReceivedHere')}</span>
            </button>
            {t('emailNotReceived2')}
          </p>
        )
      }
    />
  );
};

export default EmailConfirmationMobile;
